import { ILogoUrl } from '@shared/bff';

export const getLogoToPreview = (logos: ILogoUrl[], width: number) => {
  if (logos.length > 0) {
    const scaledLogo = logos.find((logo) => logo.size.width === width);
    return scaledLogo ? scaledLogo.url : logos[0].url;
  }
  return null;
};
